<template>
  <div
    class="store-search input-text input-text--simple input-text--48 input-text--focused"
    :class="[inputFocused]"
  >
    <div class="input-text__elements">
      <label
        class="input-text__label"
        for="search-input-field"
      >Postnummer</label>
      <input
        id="search-input-field"
        ref="actualInput"
        v-model="searchQuery"
        name="search-input-field"
        class="input-text__element"
        type="search"
        placeholder="Postnummer, butiksnamn, stad"
        @focus="onFocus"
        @blur="onBlur"
        @keyup.enter="!!searchQuery && $emit('search', searchQuery)"
      >
    </div>
    <button
      class="button button--32 store-search--button"
      :disabled="!searchQuery"
      @click="$emit('search', searchQuery)"
    >
      Sök
    </button>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'SearchInput',
  data () {
    return {
      focused: false,
      touched: false,
      searchQuery: ''
    }
  },
  computed: {
    ...mapState(['storeSearchQuery']),
    inputFocused () {
      return this.focused ? 'input-text--focused' : ''
    }
  },
   watch: {
      storeSearchQuery () {
       this.searchQuery = this.storeSearchQuery
      },
    },
  mounted: function () {
    this.searchQuery = this.storeSearchQuery
  },
  methods: {
    focus () {
      this.$refs.actualInput.focus()
    },
    onFocus () {
      this.focused = true
    },
    onBlur () {
      this.touched = true
      if (this.searchQuery.length === 0) {
        this.focused = false
      }
    }
  }
}
</script>

<style lang="scss">
.store-search {
  input[type='search']::-ms-clear {
    display: none;
    width: 0;
    height: 0;
  }

  input[type='search']::-ms-reveal {
    display: none;
    width: 0;
    height: 0;
  }

  /* clears the 'X' from Chrome */
  input[type='search']::-webkit-search-decoration,
  input[type='search']::-webkit-search-cancel-button,
  input[type='search']::-webkit-search-results-button,
  input[type='search']::-webkit-search-results-decoration {
    display: none;
  }

  &--button {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translate(-8px, -50%);

    &.button:disabled {
      color: $color-grey-light;
    }
  }
}
</style>
